import { HttpInterceptorFn } from '@angular/common/http';
import { timeout } from 'rxjs/operators';

/** Maximum time a regular API call may take before it is declared hung. */
export const API_REQUEST_TIMEOUT_MS = 30_000;

/**
 * URL substrings of requests that are slow by nature (uploads, documents, bill reading, long-lived
 * connections). They are not given the ceiling.
 */
const EXCLUDED_URL_PATTERNS: readonly string[] = [
    '/upload',
    '/download',
    '/image',
    '/pdf',
    '/stream',
    '/export',
    '/report',
    '/bulk',
    '/events',
    '/socket',
    '/poll',
];

/**
 * Gives every regular API call a 30-second ceiling, so a request that never answers ends in an error
 * the caller can handle instead of leaving a loader on screen for ever.
 */
export const requestTimeoutInterceptor: HttpInterceptorFn = (request, next) => {
    const url = request.url.toLowerCase();
    if (EXCLUDED_URL_PATTERNS.some((pattern) => url.includes(pattern))) {
        return next(request);
    }
    return next(request).pipe(timeout({ each: API_REQUEST_TIMEOUT_MS }));
};
